<template>
	<div
		class="main-layout"
		:style="!getIsMounted ? 'position: absolute' : 'position: relative'"
	>
		<template v-if="loading">
			<div
				style="height: 100vh; width: 100vw; padding: 20px 0; background: #FFF;"
			>
				<div style="position: relative; top: 50%">
					<loadingComp :width="30" :height="30" color="#82b1ff" />
				</div>
			</div>
		</template>
		<template v-else>
			<div class="erors-layout" v-if="error">
				<div class="error-layout-img">
					<svg
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink"
						x="0px"
						y="0px"
						viewBox="0 0 1000 1000"
						enable-background="new 0 0 1000 1000"
						xml:space="preserve"
						id="animate-parent"
					>
						<g>
							<g
								class="svg-image"
								transform="translate(0.000000,511.000000) scale(0.100000,-0.100000)"
							>
								<path
									d="M671,1634.8c-39.2-30.9-571-1321.4-571-1389.4c0-22.7,20.6-61.8,45.4-84.5c37.1-33,3040.6-1267.8,3360.1-1381.1c129.9-45.4,167-12.4,272.1,239.1c263.9,632.9,445.3,1100.8,445.3,1152.3c0,33-16.5,74.2-37.1,92.8c-45.4,41.2-3384.9,1395.6-3440.6,1395.6C722.6,1659.6,689.6,1647.2,671,1634.8z M947.3,1472c84.5-35,154.6-66,156.7-68c10.3-8.2-86.6-239.1-101-239.1c-6.2,0-90.7,33-189.6,74.2L638,1313.2l39.2,101c22.7,55.7,41.2,107.2,41.2,111.3C718.4,1552.4,811.2,1529.7,947.3,1472z M1460.6,1263.8c84.5-33,156.7-63.9,160.8-66c10.3-10.3-84.5-239.1-98.9-239.1c-24.7,0-420.5,164.9-439.1,183.5c-8.3,8.2,4.1,68,28.9,131.9l43.3,115.4l76.3-30.9C1273,1340,1376,1298.8,1460.6,1263.8z M899.8,1154.5c47.4-18.6,86.6-43.3,86.6-51.5c0-16.5-119.6-313.3-131.9-323.6c-4.1-4.1-90.7,24.7-193.8,66l-187.6,76.3l72.2,164.9c39.2,90.7,70.1,169,70.1,173.2C615.4,1265.8,671,1247.3,899.8,1154.5z M1918.2,1080.3c117.5-45.3,216.5-88.6,220.6-92.8c10.3-8.2-59.8-197.9-82.5-222.6c-12.4-14.4-426.7,131.9-470,164.9c-12.4,12.4,84.5,235,103.1,235C1699.7,1164.8,1802.8,1127.7,1918.2,1080.3z M1287.4,997.8c111.3-47.4,208.2-88.6,212.3-92.8c10.3-10.3-98.9-298.9-123.7-325.7c-12.4-14.4-426.7,131.9-470,164.9c-16.5,14.4,127.8,338.1,152.5,338.1C1070.9,1082.4,1174,1043.2,1287.4,997.8z M2433.6,872.1c121.6-49.5,222.6-98.9,222.6-111.3c0-12.4-18.5-70.1-43.3-125.7l-43.3-105.1l-228.8,92.8c-127.8,51.5-232.9,94.8-235,96.9c-8.2,8.2,86.6,239.1,96.9,239.1C2206.8,958.7,2311.9,919.5,2433.6,872.1z M734.9,762.8c47.4-18.5,86.6-43.3,86.6-53.6c0-24.7-105.1-292.7-123.7-313.3c-14.4-16.5-323.7,94.8-356.6,127.8c-10.3,10.3,12.4,90.7,49.5,183.5l68,164.9l94.8-37.1C605.1,814.4,685.4,781.4,734.9,762.8z M1794.5,791.7c117.5-45.3,218.5-88.6,226.8-92.8c14.4-10.3-96.9-294.8-127.8-325.7c-12.4-12.4-410.2,123.7-467.9,162.9c-12.4,6.2,129.9,340.1,142.2,340.1C1576,876.2,1679.1,839.1,1794.5,791.7z M2981.9,649.5l208.2-86.6l-41.2-107.2c-22.7-57.7-47.4-111.3-55.7-119.6c-8.3-6.2-117.5,28.9-245.3,80.4l-228.8,94.8l39.2,105.1c53.6,131.9,59.8,140.2,88.6,129.9C2761.3,740.2,2866.5,696.9,2981.9,649.5z M1060.6,630.9c78.3-33,177.3-74.2,218.5-90.7l78.3-33l-63.9-150.5c-35-82.5-72.2-158.7-80.4-169c-16.5-16.5-265.9,72.1-416.4,144.3l-53.6,28.9l63.9,164.9c37.1,90.7,76.3,164.9,88.6,164.9C910.1,690.7,984.4,663.9,1060.6,630.9z M2276.9,595.9c101-41.2,204.1-82.5,228.8-92.8l47.4-16.5l-39.2-99c-22.7-55.7-53.6-131.9-72.1-175.2l-33-74.2l-235,92.8l-237.1,94.8l39.2,99c68,171.1,101,245.3,109.3,245.3C2089.3,670.1,2173.8,637.1,2276.9,595.9z M3569.4,412.4c78.3-33,136.1-66,131.9-80.4c-6.2-12.4-26.8-63.9-47.4-115.4c-18.5-51.5-37.1-94.8-39.2-98.9c-4.1-4.1-113.4,37.1-243.2,88.6l-237.1,94.8l30.9,76.3c16.5,41.2,39.2,96.9,49.5,121.6l16.5,47.4l99-39.2C3385.9,486.6,3493.1,443.3,3569.4,412.4z M1648.1,393.8c138.1-57.7,212.3-101,208.2-117.5c-14.4-76.3-119.6-307.1-138.1-307.1c-51.5,0-443.2,173.1-443.2,195.8c0,14.4,14.4,59.8,30.9,101s45.4,107.2,59.8,146.4c16.5,39.2,39.2,72.1,49.5,72.1S1530.6,443.3,1648.1,393.8z M502,398c90.7-35,167-66,171.1-68c4.1-4.1-78.3-218.5-92.8-235c-16.5-20.6-356.6,134-356.6,160.8c0,55.7,66,208.2,90.7,208.2C326.8,463.9,411.3,435.1,502,398z M2831.4,373.2c121.6-51.5,224.7-94.8,228.8-101c6.2-6.2-107.2-313.3-127.8-340.1c-2.1-4.1-109.3,37.1-241.2,90.7l-237.1,96.9l70.1,162.9c39.2,90.7,70.1,169,70.1,173.2C2594.3,470.1,2604.7,466,2831.4,373.2z M4095.1,185.6c22.7-20.6,20.6-43.3-16.5-131.9C4051.8-4,4027-51.4,4020.9-51.4c-43.3,0-354.6,138.1-354.6,156.7c0,12.4,18.5,70.1,43.3,127.8l43.3,103.1l156.7-63.9C3998.2,239.2,4080.6,198,4095.1,185.6z M965.8,212.4c119.6-47.4,218.5-86.6,222.6-88.6c6.2-6.2-76.3-222.6-90.7-235C1081.2-129.8,636,59.9,636,84.6c0,39.2,78.3,214.4,96.9,214.4C741.1,299,846.2,259.8,965.8,212.4z M2145,193.9c117.5-45.3,220.6-90.7,228.8-98.9c14.4-14.4-107.2-334-131.9-340.1c-24.7-6.2-451.5,179.3-451.5,195.8c0,24.7,127.8,327.8,136.1,327.8C1930.6,278.4,2029.5,241.3,2145,193.9z M3445.7,123.8c76.3-30.9,138.1-61.8,138.1-70.1c0-12.4-123.7-315.4-134-327.8c-8.2-8.3-428.8,160.8-449.4,179.3c-8.3,8.3,12.4,90.7,49.5,183.5l66,167l94.8-39.2C3262.3,195.9,3367.4,154.7,3445.7,123.8z M1468.8,8.3c115.4-47.4,214.4-90.7,224.7-98.9c20.6-20.6-68-228.8-98.9-228.8c-24.7,0-422.6,156.7-439.1,175.2c-12.4,10.3,78.3,237.1,94.8,237.1C1256.5,92.9,1355.4,55.8,1468.8,8.3z M2666.5-18.4c121.6-51.5,224.7-96.9,230.9-103.1c10.3-10.3-115.4-342.2-129.9-342.2c-16.5,0-430.8,173.1-447.3,185.5c-12.4,10.3,103.1,350.4,119.6,350.4C2443.9,72.3,2544.9,31,2666.5-18.4z M3771.4-8.1c49.5-22.7,125.7-53.6,167-70.1l78.3-33l-63.9-150.5c-35-82.5-72.1-158.7-80.4-169c-18.5-18.5-342.2,101-360.8,131.9C3495.2-272,3629.2,31,3656,31C3670.4,31,3722,12.5,3771.4-8.1z M1980-197.8c117.5-45.3,220.6-90.7,230.9-101c22.7-22.7-72.1-251.5-98.9-239.1c-12.4,4.1-115.4,47.4-226.8,92.8c-113.4,47.4-208.2,88.7-212.3,92.8c-8.2,6.2,78.3,239.1,88.6,239.1C1765.6-113.3,1864.6-150.4,1980-197.8z M3208.6-239c115.4-47.4,210.3-92.8,210.3-103.1c0-24.7-105.1-292.7-123.7-313.3c-14.4-16.5-424.7,136-459.7,169c-20.6,18.6,111.3,331.9,138.1,331.9C2986-154.5,3091.2-191.6,3208.6-239z M2726.3-507c16.5-14.4-35-193.8-68-230.9c-14.4-12.4-424.7,138.1-461.8,171.1c-8.3,8.2,6.2,66,35,129.9l49.5,115.4l214.4-84.5C2612.9-453.4,2716-498.8,2726.3-507z M3676.6-430.7c103.1-43.3,162.9-80.4,158.7-96.9c-14.4-76.3-119.6-307.1-138.1-307.1c-16.5,0-338.1,121.6-356.6,136c-14.4,10.3,131.9,338.1,150.5,338.1C3503.4-360.6,3585.9-391.6,3676.6-430.7z M3019-620.4c278.3-113.4,261.8-94.8,212.3-210.3c-22.7-53.6-49.5-105.1-57.7-113.4c-12.4-12.4-391.7,121.6-457.6,162.8c-20.6,12.4,70.1,235,96.9,235C2823.2-546.2,2915.9-579.2,3019-620.4z M3501.4-816.2c84.5-35,160.8-70.1,171.1-78.3c18.6-16.5-66-228.8-90.7-228.8c-49.5,0-348.4,134-348.4,156.7c0,39.2,78.3,214.4,96.9,214.4C3340.6-752.3,3416.9-781.2,3501.4-816.2z"
								/>
								<path
									d="M4668.2,686.6c-74.2-70.1-1111.1-2642.8-1094.6-2719c6.2-30.9,33-72.1,57.7-94.8c57.7-51.5,1478.1-624.6,1548.1-624.6c117.5,0,136.1,39.2,682.3,1389.4C6150.3-649.2,6387.4-47.3,6387.4-26.7c0,22.7-14.4,65.9-28.9,96.9c-26.8,49.5-123.7,94.8-779.2,360.8c-412.3,164.9-773,301-804,301C4744.4,731.9,4697,711.3,4668.2,686.6z"
								/>
								<path
									d="M6340-686.3c-51.5-55.7-550.4-1298.7-550.4-1368.8c0-30.9,18.6-74.2,39.2-92.8c53.6-45.4,3372.5-1387.4,3432.3-1387.4c26.8,0,68,16.5,90.7,37.1c20.6,18.6,158.8,329.8,303,688.5c276.2,690.6,286.5,725.6,189.6,787.5c-88.6,57.7-3362.2,1372.9-3415.8,1372.9C6397.7-649.2,6358.5-665.7,6340-686.3z M6616.2-826.5l181.4-74.2l-51.5-115.4c-28.9-63.9-53.6-117.5-55.7-119.6c-6.2-6.2-346.3,131.9-360.7,144.3c-12.4,12.4,78.3,239.1,94.8,239.1C6432.8-752.3,6519.3-785.3,6616.2-826.5z M7174.9-1051.2l138.1-55.7l-41.2-105.1c-22.7-59.8-47.4-113.4-55.7-121.6c-8.2-6.2-117.5,28.9-245.3,80.4l-230.9,92.8l41.2,105.1c22.7,57.7,45.4,111.3,51.5,121.6C6843-919.3,6871.8-929.6,7174.9-1051.2z M6451.3-1094.5c72.1-30.9,152.6-61.8,177.3-72.1l47.4-16.5l-41.2-103.1c-20.6-57.7-53.6-136-70.1-175.2l-30.9-72.1l-181.4,72.1c-98.9,41.2-183.5,76.3-185.5,78.3c-10.3,8.2,127.8,342.2,140.2,342.2C6313.2-1040.9,6377.1-1065.7,6451.3-1094.5z M7665.5-1251.2c84.5-33,156.7-63.9,160.8-66c4.1-6.2-78.3-218.5-92.8-237.1c-2.1-4.1-111.3,35-241.2,88.6l-235,99l53.6,119.6l51.5,121.6l74.2-30.9C7477.9-1174.9,7581-1216.1,7665.5-1251.2z M6954.3-1296.5c121.6-51.5,224.7-94.8,228.8-101c6.2-6.2-107.2-313.3-127.8-340.1c-2.1-4.1-111.3,37.1-241.2,90.7l-237.1,96.9l70.1,164.9c39.2,92.8,70.1,171.1,70.1,173.2C6717.2-1199.6,6735.8-1207.9,6954.3-1296.5z M8123.1-1434.7c117.5-45.3,216.5-86.6,220.6-92.8c10.3-10.3-82.5-235-96.9-235c-8.2,0-113.4,39.2-237.1,88.6c-243.2,94.8-237.1,84.5-169,247.4c16.5,41.2,41.2,76.3,51.5,76.3S8007.7-1387.2,8123.1-1434.7z M7566.5-1548c72.1-28.8,134-57.7,138.1-61.8c10.3-10.3-125.8-338.1-142.2-338.1c-24.7,0-420.5,164.9-439.1,183.5c-8.3,8.2,12.4,90.7,49.5,183.5l66,167l98.9-39.2C7391.3-1475.9,7494.4-1517.1,7566.5-1548z M6335.9-1504.7c80.4-33,150.5-63.9,160.8-72.1c10.3-8.3-86.6-290.7-119.6-344.3c-2.1-4.1-86.6,28.9-189.7,70.1l-189.7,74.2l39.2,98.9c86.6,218.5,103.1,249.4,127.8,239.1C6179.2-1445,6257.5-1473.8,6335.9-1504.7z M8634.4-1642.9c119.6-47.4,220.6-88.6,224.7-90.7c14.4-12.4-70.1-220.6-92.8-228.8c-18.6-6.2-435,146.3-459.7,171.1c-10.3,10.3,82.5,235,99,235C8411.7-1556.3,8514.8-1595.4,8634.4-1642.9z M6807.9-1698.5c113.4-47.4,208.2-88.6,214.4-94.8c10.3-8.3-117.5-340.1-131.9-340.1c-20.6,0-432.9,171.1-447.3,183.4c-22.7,22.7,113.4,354.6,140.2,344.3C6595.6-1609.9,6696.6-1653.2,6807.9-1698.5z M8007.7-1725.3c117.5-47.4,214.4-94.8,214.4-105.1c0-33-127.8-323.7-142.2-323.7c-24.7,0-422.6,164.9-439.1,181.4c-20.6,20.6,105.2,334,134,334C7785.1-1638.7,7892.2-1677.9,8007.7-1725.3z M9145.6-1847c117.5-47.4,218.5-96.9,222.6-111.3c6.2-14.4-10.3-72.1-37.1-129.9l-47.4-103.1l-216.5,90.7c-119.6,49.5-222.6,92.8-232.9,94.8c-14.4,6.2,70.1,243.2,88.6,243.2C8929.1-1762.4,9030.2-1801.6,9145.6-1847z M6170.9-1896.4c80.4-33,152.6-66,162.9-74.2c14.4-12.4-61.8-245.3-80.4-245.3c-12.4,0-348.4,146.3-358.7,154.6c-16.5,18.5,86.6,239.1,109.3,230.9C6016.3-1836.7,6092.6-1865.5,6170.9-1896.4z M7331.5-1908.8c115.5-47.4,210.3-94.8,210.3-105.1c0-30.9-125.7-325.7-140.2-325.7c-20.6,0-426.7,169-443.2,183.5c-20.6,20.6,109.3,331.9,138.1,331.9C7108.9-1824.3,7214-1861.4,7331.5-1908.8z M8516.9-1931.5c117.5-49.5,216.5-96.9,218.5-105.1c4.1-8.3-22.7-88.7-59.8-177.3l-63.9-162.8l-230.9,92.8c-127.8,51.5-232.9,94.8-235,96.9c-10.3,10.3,127.8,342.2,142.2,342.2C8296.3-1844.9,8399.4-1884.1,8516.9-1931.5z M9644.5-2051c167-66,169-68,117.5-191.7c-22.7-59.8-45.4-109.3-47.4-113.4c-2.1-4.1-86.6,26.8-189.6,68l-187.6,76.3l41.2,105.1c55.7,140.2,53.6,138.1,107.2,119.6C9510.5-1997.4,9582.6-2026.3,9644.5-2051z M6855.4-2183c12.4-12.4-49.5-195.8-76.3-224.7c-12.4-14.4-418.5,136.1-459.7,171.1c-8.3,8.2,8.2,66,35,129.9l51.5,115.4l220.6-90.7C6746.1-2131.4,6849.2-2176.8,6855.4-2183z M7842.8-2117c117.5-47.4,214.4-96.9,214.4-109.3c0-30.9-103.1-284.5-123.7-307.2c-14.4-12.4-422.6,129.9-470,162.9c-12.4,10.3,129.9,340.1,148.4,340.1C7622.2-2030.4,7727.3-2069.6,7842.8-2117z M8997.2-2125.3c101-41.2,204.1-82.5,228.8-92.8l47.4-16.5l-39.2-98.9c-22.7-55.7-53.6-131.9-72.1-175.2l-33-74.2l-235,92.8l-237.1,94.8l39.2,98.9c68,171.1,101,245.3,109.3,245.3C8809.6-2051,8894.1-2084,8997.2-2125.3z M7141.9-2290.2c278.3-113.4,261.8-94.8,212.3-210.2c-22.7-53.6-49.5-105.2-57.7-113.4c-12.4-12.4-391.7,121.6-457.6,162.8c-20.6,12.4,70.1,235,96.9,235C6946-2215.9,7038.8-2248.9,7141.9-2290.2z M8349.9-2321.1c117.5-45.3,218.5-90.7,226.8-96.9c12.3-14.4-115.5-344.3-134-344.3c-4.1,0-109.3,41.2-235,92.8l-228.8,92.8l39.2,96.9c72.1,183.5,99,243.2,109.3,243.2C8133.4-2236.6,8234.4-2273.7,8349.9-2321.1z M9599.1-2370.5c47.4-18.6,86.6-43.3,86.6-51.5c0-16.5-119.6-313.3-131.9-323.7c-4.1-4.1-90.7,24.7-193.8,66l-187.6,76.3l72.1,164.9c39.2,90.7,70.1,169,70.1,173.1C9314.6-2259.2,9370.3-2277.8,9599.1-2370.5z M7677.9-2506.6c111.3-47.4,210.3-90.7,216.4-98.9c20.6-18.5-65.9-228.8-92.8-228.8c-51.5,0-445.3,173.1-445.3,197.9c0,41.2,80.4,214.4,98.9,214.4C7465.5-2422.1,7564.5-2459.2,7677.9-2506.6z M8881.7-2535.5c107.2-43.3,204.1-84.5,212.3-92.8c12.4-10.3-86.6-292.7-121.6-346.3c-4.1-8.3-426.7,162.9-449.4,183.5c-24.7,22.7,111.3,352.5,140.2,342.2C8675.6-2455.1,8774.5-2494.2,8881.7-2535.5z M8185-2712.8c117.5-45.3,218.5-90.7,228.8-98.9c8.3-8.2-6.2-66-33-129.9l-45.4-115.4l-224.7,90.7c-123.7,49.5-228.8,94.8-235,99c-10.3,10.3,76.3,239.1,90.7,239.1C7970.6-2628.2,8069.5-2665.3,8185-2712.8z M9364.1-2731.3c86.6-37.1,156.7-74.2,156.7-84.5c0-24.7-105.1-292.7-123.7-313.3c-14.4-16.5-323.7,94.8-358.7,129.9c-24.7,24.7,113.4,354.6,144.3,342.2C9197.1-2663.3,9279.6-2696.2,9364.1-2731.3z M8716.8-2927.1c107.2-43.3,204.1-86.6,214.4-94.8c24.7-22.7-70.1-249.5-99-239.1c-12.4,6.2-111.3,45.4-218.5,86.6c-107.2,43.3-204.1,84.5-212.3,92.8c-22.7,20.6,70.1,251.5,96.9,241.2C8510.7-2846.7,8609.6-2885.9,8716.8-2927.1z M9331.1-3298.2c-22.7-55.7-47.4-111.3-57.7-119.6c-14.4-16.5-317.5,94.8-356.6,129.9c-8.3,8.3,6.2,66,35,129.9l51.5,115.4l183.5-76.3l185.5-74.2L9331.1-3298.2z"
								/>
							</g>
						</g>
						<g id="animate-satellite">
							<g
								class="svg-image"
								transform="translate(0.000000,511.000000) scale(0.100000,-0.100000)"
							>
								<path
									d="M6164.8,2317.2c-125.8-37.1-183.5-200-117.5-327.8c30.9-59.8,26.8-72.1-101-385.5c-84.5-208.2-142.2-323.6-160.8-321.6c-14.4,4.1-268,103.1-560.7,222.6c-377.2,152.5-542.2,210.3-556.6,195.8c-12.4-12.4-20.6-76.3-20.6-144.3c6.2-424.7,583.4-911.2,1300.8-1094.6c257.7-66,620.5-68,810.1-2.1c146.3,49.5,272.1,140.2,319.5,228.8l28.9,57.7l-550.4,220.6c-303,121.6-556.6,228.8-564.8,237.1c-8.2,8.2,41.2,160.8,113.4,338.1c109.2,280.4,134,325.7,179.3,338.1c131.9,30.9,216.5,193.8,160.8,307.2C6393.6,2296.5,6278.1,2348.1,6164.8,2317.2z M6342,2218.2c-4.1-41.2-16.5-53.6-57.7-53.6c-61.8,0-82.5,68-30.9,105.1C6304.9,2308.9,6350.3,2282.1,6342,2218.2z"
								/>
							</g>
						</g>
						<g id="animate-puls">
							<g
								class="svg-image"
								transform="translate(0.000000,511.000000) scale(0.100000,-0.100000)"
							>
								<path
									d="M5935.9,3741.6c-597.8-125.8-1080.2-552.5-1267.8-1119.4c-43.3-129.9-41.2-173.2,8.2-200c72.1-39.2,117.5-6.2,156.7,109.3c125.8,387.6,404,717.4,750.4,888.5c228.8,111.3,414.3,156.7,659.7,156.7s430.8-45.4,659.7-156.7c162.9-80.4,226.8-125.8,373.1-274.2c191.7-191.7,292.7-352.5,367-581.3c117.5-358.7,84.5-783.3-82.5-1115.2c-72.2-142.2-57.7-202,45.3-202c55.7,0,68,12.4,131.9,150.5c123.7,257.7,160.8,453.5,150.5,777.2c-8.2,230.9-20.6,305.1-66,443.2c-88.6,259.7-208.2,451.5-404,651.4c-206.1,208.2-383.4,319.5-659.7,412.3c-173.2,57.7-226.8,66-463.8,72.2C6148.3,3758.1,5985.4,3751.9,5935.9,3741.6z"
								/>
							</g>
						</g>

						<g id="animate-puls-2">
							<g
								class="svg-image"
								transform="translate(0.000000,511.000000) scale(0.100000,-0.100000)"
							>
								<path
									d="M6109.1,3378.8c-22.7-4.1-92.8-18.5-154.6-30.9c-173.2-33-426.7-164.9-568.9-294.8c-152.6-138.1-282.4-331.9-350.4-521.6c-59.8-173.2-61.9-224.7-8.3-253.5c78.3-41.2,117.5-8.2,162.9,140.2c144.3,476.2,651.4,826.6,1129.7,779.2c793.7-78.3,1249.2-894.7,892.6-1599.7c-74.2-148.4-74.2-154.6-12.4-195.8c70.1-47.4,109.3-20.6,179.3,117.5c416.4,824.6-146.4,1803.8-1067.8,1859.4C6222.5,3385,6131.8,3385,6109.1,3378.8z"
								/>
							</g>
						</g>

						<g id="animate-puls-3">
							<g
								class="svg-image"
								transform="translate(0.000000,511.000000) scale(0.100000,-0.100000)"
							>
								<path
									d="M5971,2980.9c-169-55.7-284.5-127.8-404-259.7c-125.8-136.1-210.3-307.2-224.7-453.5c-10.3-96.9-6.2-111.3,33-131.9c70.1-39.2,119.6,2.1,144.3,121.6c47.4,224.7,183.5,397.9,389.6,498.9c125.8,61.8,152.6,68,334,68c173.2,0,210.3-6.2,313.3-57.7c152.5-74.2,309.2-245.3,366.9-402c37.1-94.8,43.3-152.6,37.1-294.8c-6.2-158.7-14.4-193.8-82.5-325.7l-78.3-146.4l43.3-43.3c61.8-61.8,103.1-41.2,179.3,84.5c103.1,171.1,134,303,123.7,525.7c-6.2,162.9-16.5,210.3-74.2,323.6C6863.6,2910.9,6401.8,3117,5971,2980.9z"
								/>
							</g>
						</g>
					</svg>
				</div>
				<p class="error-layout-text">
					Отсутствует интернет соединение. Проверьте подключение к
					сети и повторите попытку.
				</p>
				<span class="button-reload" @click="reload()">Повторить</span>
			</div>

			<template v-else>
				<slot name="body"></slot>
			</template>
		</template>
	</div>
</template>

<script>
import loadingComp from "./loading";
import { mapGetters } from "vuex";

export default {
	data() {
		return {};
	},
	props: {
		error: {
			default: false,
			type: Boolean
		},
		loading: {
			default: false,
			type: Boolean
		}
	},
	computed: {
		...mapGetters([
			'getIsMounted'
		])
	},
	methods: {
		reload() {
			this.$emit("reload");
		}
	},
	components: {
		loadingComp
	}
};
</script>

<style scoped>
.main-layout {
	position: relative;
	top: 0px;
	z-index: 199;
	flex-grow: 1;
}

.erors-layout {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	height: 500px;
}

.error-layout-text {
	text-align: center;
	font-size: 16px;
	font-weight: bold;
}

.button-reload {
	color: #fff;
	background: #09f;
	display: inline-block;
	padding: 13px 55px;
	border: none;
	margin: 20px 0;
}

.error-layout-img {
	width: 300px;
	height: 300px;
}

.svg-image path {
	fill: #242424;
}

#animate-parent {
	position: relative;
	top: 0;
	animation-name: parent-satellite;
	animation-duration: 3s;
	animation-fill-mode: both;
	animation-iteration-count: 15;
}

@keyframes parent-satellite {
	0% {
		top: 5px;
	}
	50% {
		top: -5px;
	}
	100% {
		top: 5px;
	}
}

#animate-satellite {
	transform: rotate(0deg);
	transform-origin: 50% 50%;
	animation-name: start-satellite;
	animation-duration: 4s;
	animation-fill-mode: both;
	animation-iteration-count: 5;
}

#animate-puls {
	transform: rotate(0deg);
	transform-origin: 50% 50%;
	animation-name: start-satellite-radio, start-satellite;
	animation-duration: 4s;
	animation-fill-mode: both;
	animation-iteration-count: 5;
}

#animate-puls-2 {
	transform: rotate(0deg);
	transform-origin: 50% 50%;
	animation-name: start-satellite-radio-2, start-satellite;
	animation-duration: 4s;
	animation-fill-mode: both;
	animation-iteration-count: 5;
}

#animate-puls-3 {
	transform: rotate(0deg);
	transform-origin: 50% 50%;
	animation-name: start-satellite-radio-3, start-satellite;
	animation-duration: 4s;
	animation-fill-mode: both;
	animation-iteration-count: 5;
}

@keyframes start-satellite {
	0% {
		transform: rotate(0deg);
	}
	25% {
		transform: rotate(15deg);
	}
	75% {
		transform: rotate(-15deg);
	}
	100% {
		transform: rotate(0deg);
	}
}

@keyframes start-satellite-radio {
	0% {
		opacity: 0.7;
	}
	20% {
		opacity: 1;
	}
	40% {
		opacity: 0.7;
	}
	60% {
		opacity: 1;
	}
	80% {
		opacity: 0.7;
	}
	100% {
		opacity: 1;
	}
}
@keyframes start-satellite-radio-2 {
	0% {
		opacity: 0.5;
	}
	20% {
		opacity: 1;
	}
	40% {
		opacity: 0.5;
	}
	60% {
		opacity: 1;
	}
	80% {
		opacity: 0.5;
	}
	100% {
		opacity: 1;
	}
}
@keyframes start-satellite-radio-3 {
	0% {
		opacity: 0.3;
	}
	20% {
		opacity: 1;
	}
	40% {
		opacity: 0.3;
	}
	60% {
		opacity: 1;
	}
	80% {
		opacity: 0.3;
	}
	100% {
		opacity: 1;
	}
}
</style>
